import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'
import { Dropdown } from 'react-bootstrap'
import { DropdownSVG } from 'src/components/Icons/Basic'
import { BASIC_DROPDOWN_SIZE } from './BasicDropdown.constants'

export const BasicDropdownToggle = styled(Dropdown.Toggle)<{
  $backgroundColor?: string
  $borderColor?: string
  $size?: BASIC_DROPDOWN_SIZE
}>`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
  padding: 4px 12px !important;
  border-radius: 40px !important;
  font-size: ${({ $size }) =>
    $size === BASIC_DROPDOWN_SIZE.SMALL
      ? '12px'
      : $size === BASIC_DROPDOWN_SIZE.MEDIUM
      ? '14px'
      : '12px'} !important;
  height: ${({ $size }) =>
    $size === BASIC_DROPDOWN_SIZE.SMALL
      ? '18px'
      : $size === BASIC_DROPDOWN_SIZE.MEDIUM
      ? '32px'
      : '18px'} !important;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || palette.neutral.white} !important;
  border: ${({ $borderColor }) =>
    $borderColor ? `1px solid ${$borderColor}` : 'none'} !important;
  box-shadow: none !important;

  /* Remove default Bootstrap button styles */
  &:hover,
  &:focus,
  &:active,
  &.show {
    background-color: ${({ $backgroundColor }) =>
      $backgroundColor || palette.neutral.white} !important;
    border: ${({ $borderColor }) =>
      $borderColor ? `1px solid ${$borderColor}` : 'none'} !important;
    box-shadow: none !important;
    outline: none !important;
  }
  &[aria-expanded='true'] {
    .basic-dropdown-icon {
      transform: scaleY(-1);
      transition: transform 0.35s;
    }
  }

  .basic-dropdown-icon {
    transform: scaleY(1);
    transition: transform 0.35s;
  }

  /* Remove the default caret */
  &::after {
    display: none !important;
  }

  &[disabled] {
    opacity: 1;
    cursor: default;
  }
`

export const BasicDropdownMenu = styled(Dropdown.Menu)<{
  $offset?: number
  $isFullWidth?: boolean
}>`
  border-radius: 16px !important;
  background-color: white !important;
  min-width: 200px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  padding: 6px 3px !important;
  max-height: 300px !important;
  overflow: hidden !important;
  margin-top: ${({ $offset }) => $offset || 16}px !important;
  ${({ $isFullWidth }) =>
    $isFullWidth &&
    `
    width: 100% !important;
    min-width: fit-content !important;
  `}
`

export const BasicDropdownContent = styled.div`
  max-height: 284px; /* Menu height minus padding (300px - 16px) */
  overflow-y: auto;
  cursor: default;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
    margin: 16px 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${palette.neutral[300]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${palette.neutral[400]};
  }

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: ${palette.neutral[300]} transparent;
`

export const BasicDropdownMenuItem = styled(Dropdown.Item)<{
  $isBold?: boolean
  $backgroundColor?: string
  $size?: BASIC_DROPDOWN_SIZE
  [prop: string]: unknown
}>`
  display: flex !important;
  align-items: center !important;
  padding: 4px 8px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: background-color 0.2s ease !important;
  font-size: ${({ $size }) =>
    $size === BASIC_DROPDOWN_SIZE.SMALL
      ? '12px'
      : $size === BASIC_DROPDOWN_SIZE.MEDIUM
      ? '14px'
      : '12px'} !important;
  color: ${palette.neutral[900]} !important;
  border: none !important;
  background: none !important;
  font-weight: ${({ $isBold }) => ($isBold ? 'bold' : 'normal')} !important;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || 'none'} !important;

  &:hover,
  &:focus {
    background-color: ${palette.neutral[50]} !important;
    outline: none !important;
  }

  &:active {
    background-color: ${palette.neutral[50]} !important;
  }
`

export const BasicDropdownIcon = styled(DropdownSVG).attrs({
  className: 'basic-dropdown-icon',
})`
  width: 16px;
  height: 16px;
  color: ${palette.neutral[900]};
`

export const BasicDropdownSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const BasicDropdownSectionTitle = styled.div`
  font-size: 12px;
  color: ${palette.neutral[900]};
  padding: 4px 8px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: none;
`

export const BasicDropdownSectionDivider = styled.div`
  height: 1px;
  background-color: ${palette.neutral[200]};
  margin: 4px 0;
`

export const BasicDropdownToggleText = styled.div<{ $fontColor?: string }>`
  color: ${({ $fontColor }) => $fontColor || palette.neutral[900]};
`
